// src/pages/supervisors/SupervisorsPage/index.js

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Table, Card, Button, Typography, Spin, Tag, Space } from 'antd';
import { UsergroupAddOutlined, PlusOutlined } from '@ant-design/icons'; // <-- AJOUTER PlusOutlined
import { fetchSupervisors } from '../../../redux/slices/supervisors/supervisorsThunk';
import { useHasPermission } from '../../../hooks/useHasPermission';

const { Title } = Typography;

const SupervisorsPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { data: supervisors, loading } = useSelector((state) => state.supervisors.supervisorsList);

  // Vérifier si l'utilisateur a la permission de créer
  const canCreateSupervisor = useHasPermission('supervisors:manage');

  useEffect(() => {
    dispatch(fetchSupervisors());
  }, [dispatch]);

  const handleAssignDelegates = (supervisorId) => {
    history.push(`/superviseur/${supervisorId}/assigner-delegues`);
  };

  const columns = [
    {
      title: 'Nom du Superviseur',
      dataIndex: ['user', 'firstName'],
      key: 'name',
      render: (_, record) => `${record.user?.firstName || ''} ${record.user?.lastName || ''}`.trim(),
    },
    {
      title: 'Email',
      dataIndex: ['user', 'email'],
      key: 'email',
    },
    {
      title: 'Délégués Supervisés',
      dataIndex: 'delegates',
      key: 'delegates',
      render: (delegates) => {
        if (!delegates || delegates.length === 0) {
          return <Tag>Aucun</Tag>;
        }
        return (
          <Space wrap>
            {delegates.map(delegate => (
              <Tag color="blue" key={delegate.id}>
                {`${delegate.firstname} ${delegate.lastname}`}
              </Tag>
            ))}
          </Space>
        );
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      align: 'center',
      render: (_, record) => (
        <Button
          type="primary"
          icon={<UsergroupAddOutlined />}
          onClick={() => handleAssignDelegates(record.id)}
        >
          Assigner Délégués
        </Button>
      ),
    },
  ];

   return (
    <div className="tabled">
      <Card
        bordered={false}
        className="criclebox tablespace mb-24"
        title={<Title level={4}>Gestion des Superviseurs</Title>}
        extra={
          // Afficher le bouton uniquement si l'utilisateur a la permission
          canCreateSupervisor && (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => history.push('/nouveau/superviseur')}
            >
              Ajouter un Superviseur
            </Button>
          )
        }
      >
        <Spin spinning={loading}>
          <Table
            columns={columns}
            dataSource={supervisors}
            rowKey="id"
            pagination={{ pageSize: 10 }}
          />
        </Spin>
      </Card>
    </div>
  );
};

export default SupervisorsPage;